//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Join.js";
import "../Features/Features.Feature.js";
let d=[[],[[["numCompounds"],"GetOwningCompoundWelds",{R_:{compoundJoinWeldFeatures:"Join.CompoundJoinWeld[]"}},0,0],[["numJoins"],"GetArrowSideWelds",{R_:{arrowSideWelds:"Features.Feature[]"}},0,0],[["numJoins"],"GetOtherSideWelds",{R_:{otherSideWelds:"Features.Feature[]"}},0,0]],[]];
SPLM.Join.CompoundJoinWeld = class extends SPLM.Features.Feature{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Join.CompoundJoinWeld";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;